import type { IStyle } from 'fela';

// Back button and trail on one line, so a page that has both does not carry two
// stacked rows of navigation.
export const row: IStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '16px',
  marginBottom: '24px'
};
